<!-- <template>
  <div>플래너 관리 페이지</div>
  <div>
    <div>플래너 이름: <input type="text" v-model="plannerName" /></div>
    <div>플래너 휴대전화: <input type="text" v-model="plannerPhone" /></div>
    <button
      class="btn btn-primary"
      @click="
        $store.dispatch('insertPlannerInfo', {
          name: plannerName,
          phone: plannerPhone,
        })
      "
    >
      입력
    </button>
  </div>
</template> -->

<template>
  <main>
    <div class="container-fluid">
      <div class="page-header min-height-300" style="margin-right: -24px; margin-left: -34%;">
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">
                <i class="ni ni-badge text-dark opacity-10"></i>
                <!-- <img src="../assets/img/team-1.jpg" alt="profile_image" class="shadow-sm w-100 border-radius-lg"/> -->
              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">플래너 관리</h5>
                <p class="mb-0 font-weight-bold text-sm">플래너 등록, 삭제 등 플래너를 관리합니다.</p>
              </div>
            </div>
            <!-- <div class=" mx-auto mt-3 col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0">
              <div class="nav-wrapper position-relative end-0">
                <ul class="p-1 bg-transparent nav nav-pills nav-fill" role="tablist">
                  <li class="nav-item">
                    <a class="px-0 py-1 mb-0 nav-link active" data-bs-toggle="tab" href="javascript:;" role="tab" aria-selected="true">
                      <svg class="text-dark" width="16px" height="16px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" >
                          <g transform="translate(-2319.000000, -291.000000)" fill="#FFFFFF" fill-rule="nonzero" >
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(603.000000, 0.000000)">
                                <path class="color-background" d="M22.7597136,19.3090182 L38.8987031,11.2395234 C39.3926816,10.9925342 39.592906,10.3918611 39.3459167,9.89788265 C39.249157,9.70436312 39.0922432,9.5474453 38.8987261,9.45068056 L20.2741875,0.1378125 L20.2741875,0.1378125 C19.905375,-0.04725 19.469625,-0.04725 19.0995,0.1378125 L3.1011696,8.13815822 C2.60720568,8.38517662 2.40701679,8.98586148 2.6540352,9.4798254 C2.75080129,9.67332903 2.90771305,9.83023153 3.10122239,9.9269862 L21.8652864,19.3090182 C22.1468139,19.4497819 22.4781861,19.4497819 22.7597136,19.3090182 Z" />
                                <path class="color-background" d="M23.625,22.429159 L23.625,39.8805372 C23.625,40.4328219 24.0727153,40.8805372 24.625,40.8805372 C24.7802551,40.8805372 24.9333778,40.8443874 25.0722402,40.7749511 L41.2741875,32.673375 L41.2741875,32.673375 C41.719125,32.4515625 42,31.9974375 42,31.5 L42,14.241659 C42,13.6893742 41.5522847,13.241659 41,13.241659 C40.8447549,13.241659 40.6916418,13.2778041 40.5527864,13.3472318 L24.1777864,21.5347318 C23.8390024,21.7041238 23.625,22.0503869 23.625,22.429159 Z" opacity="0.7" />
                                <path class="color-background" d="M20.4472136,21.5347318 L1.4472136,12.0347318 C0.953235098,11.7877425 0.352562058,11.9879669 0.105572809,12.4819454 C0.0361450918,12.6208008 6.47121774e-16,12.7739139 0,12.929159 L0,30.1875 L0,30.1875 C0,30.6849375 0.280875,31.1390625 0.7258125,31.3621875 L19.5528096,40.7750766 C20.0467945,41.0220531 20.6474623,40.8218132 20.8944388,40.3278283 C20.963859,40.1889789 21,40.0358742 21,39.8806379 L21,22.429159 C21,22.0503869 20.7859976,21.7041238 20.4472136,21.5347318 Z" opacity="0.7" />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span class="ms-1">App</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="px-0 py-1 mb-0 nav-link" data-bs-toggle="tab" href="javascript:;" role="tab" aria-selected="false" >
                      <svg class="text-dark" width="16px" height="16px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >
                        <title>document</title>
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" >
                          <g transform="translate(-1870.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero" >
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(154.000000, 300.000000)">
                                <path class="color-background" d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z" opacity="0.603585379" />
                                <path class="color-background" d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z" />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span class="ms-1">Messages</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="px-0 py-1 mb-0 nav-link" data-bs-toggle="tab" href="javascript:;" role="tab" aria-selected="false" >
                      <svg class="text-dark" width="16px" height="16px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >
                        <title>settings</title>
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" >
                          <g transform="translate(-2020.000000, -442.000000)" fill="#FFFFFF" fill-rule="nonzero" >
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(304.000000, 151.000000)">
                                <polygon class="color-background" opacity="0.596981957" points="18.0883333 15.7316667 11.1783333 8.82166667 13.3333333 6.66666667 6.66666667 0 0 6.66666667 6.66666667 13.3333333 8.82166667 11.1783333 15.315 17.6716667" />
                                <path class="color-background" d="M31.5666667,23.2333333 C31.0516667,23.2933333 30.53,23.3333333 30,23.3333333 C29.4916667,23.3333333 28.9866667,23.3033333 28.48,23.245 L22.4116667,30.7433333 L29.9416667,38.2733333 C32.2433333,40.575 35.9733333,40.575 38.275,38.2733333 L38.275,38.2733333 C40.5766667,35.9716667 40.5766667,32.2416667 38.275,29.94 L31.5666667,23.2333333 Z" opacity="0.596981957" />
                                <path class="color-background" d="M33.785,11.285 L28.715,6.215 L34.0616667,0.868333333 C32.82,0.315 31.4483333,0 30,0 C24.4766667,0 20,4.47666667 20,10 C20,10.99 20.1483333,11.9433333 20.4166667,12.8466667 L2.435,27.3966667 C0.95,28.7083333 0.0633333333,30.595 0.00333333333,32.5733333 C-0.0583333333,34.5533333 0.71,36.4916667 2.11,37.89 C3.47,39.2516667 5.27833333,40 7.20166667,40 C9.26666667,40 11.2366667,39.1133333 12.6033333,37.565 L27.1533333,19.5833333 C28.0566667,19.8516667 29.01,20 30,20 C35.5233333,20 40,15.5233333 40,10 C40,8.55166667 39.685,7.18 39.1316667,5.93666667 L33.785,11.285 Z" />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span class="ms-1">Settings</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="py-4 container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card editArea">
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <button class="btn btn-outline-danger btn-sm ms-auto" v-if="isModify" @click="insertMode">취소</button>
                  <button class="btn btn-warning btn-sm ms-3" v-if="isModify" @click="modifyPlannerInfo">저장</button>
                  <button class="btn btn-success btn-sm ms-auto" v-if="!isModify" @click="insertPlannerInfo">추가</button>
                </div>
              </div>
              <div class="card-body">
                <p class="text-uppercase text-md fw-bold">필수 정보</p>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="plannerName" class="form-control-label">이름</label>
                    <input id="plannerName" class="form-control invalid" type="text" v-model="plannerName" placeholder="이름"/>
                  </div>
                  <div class="col-md-12 mb-2">
                    <label for="plannerPhone" class="form-control-label">휴대전화</label>
                    <div class="row">
                      <div class="col-md-3">
                        <select id="plannerPlanner" class="form-control" v-model="plannerTelecom">
                          <option value="0">통신사 선택</option>
                          <option value="SKT">SKT</option>
                          <option value="KT">KT</option>
                          <option value="LGU+">LGU+</option>
                          <option value=">SKT 알뜰폰">SKT 알뜰폰</option>
                          <option value="KT 알뜰폰">KT 알뜰폰</option>
                          <option value="LGU+ 알뜰폰">LGU+ 알뜰폰</option>
                        </select>
                      </div>
                      <div class="col-md-9">
                        <input id="plannerPhone" class="form-control invalid" type="text" v-model="plannerPhone" placeholder="휴대전화(숫자만)" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mb-2">
                    <label for="plannerAddress" class="form-control-label">주소</label>
                    <div class="row">
                        <div class="col-md-3">
                            <input class="form-control invalid float-start" type="text" v-model="postalCode" placeholder="우편번호" disabled>
                        </div>
                        <div class="col-md-3">
                            <button class="btn btn-dark" @click="execDaumPostcode()">우편번호찾기</button>
                        </div>
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <input class="form-control invalid" type="text" v-model="address" placeholder="기본주소" disabled  >
                        </div>
                        <div class="col-md-6 mb-2">
                            <input class="form-control invalid" type="text" v-model="extraAddress" placeholder="참고항목" disabled>
                        </div>
                        <div class="col-md-12">
                            <input id="plannerAddress" class="form-control invalid" type="text" v-model="detailAddress" placeholder="상세주소">
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-md-4">
            <div class="card">
              <div class="card-header pb-0 px-3">
                <span class="mb-0 float-start" style="font-size: 1rem; line-height: 1.625; font-weight: 600; margin-top: 0; color: #344767">플래너 목록</span>
                <input type="text" class="form-control float-end" placeholder="검색어 입력" @input="search($event.target.value)" style="display: inline; width: 50%;"/>
              </div>
              <div class="card-body pt-4 p-3">
                <ul class="list-group ulPlannerList onmaum-overflow-y onmaum-overflow-type02">
                  <li class="list-group-item border-0 p-4 mb-2 mb-3 bg-gray-100 border-radius-lg" :class="'class-' + planner._id" v-for="(planner, i) in plannerInfo" :key="i">
                    <div class="flex-column">
                      <div class="ms-auto row">
                        <div class="col-md-6">
                          <span class="mb-3 text-md text-dark" style="font-weight: 600;">{{planner.name}}</span>
                        </div>
                        <div class="col-md-3">
                          <button class="btn btn-link text-danger text-gradient px-3 mb-0" @click="deletePlannerInfo(planner)">
                            <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
                          </button>
                        </div>
                        <div class="col-md-3">
                          <button class="btn btn-link text-dark px-3 mb-0" @click="modifyMode(planner._id)">
                            <i class="fas fa-pencil-alt text-dark me-2" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                      <div class="mb-2 text-xs">
                        휴대전화
                        <span class="text-dark ms-sm-2 font-weight-bold">{{ `(${planner.phone.telecom}) ${planner.phone.phone}` }}</span>
                      </div>
                      <div class="mb-2 text-xs">
                        주소
                        <span class="text-dark ms-sm-2 font-weight-bold">{{ `${planner.address.address} ${planner.address.extra_address}, ${planner.address.detail_address}` }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  </main>
</template>
  
<script>
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";

import $ from 'jquery';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "PlannerManage",
  data() {
    return {
      plannerName: '',
      plannerTelecom: '0',
      plannerPhone: '',
      
      postalCode: '',
      address: '',
      detailAddress: '',
      extraAddress: '',

      isModify: false,
      modifyID: 0,
    }
  },
  watch: {
    //휴대전화 체크
    plannerPhone(a){
      if (/\D/g.test(a)){
        this.$store.commit('setAlert', {
                                          'alertStatus': 'notice'
                                          ,'alertTitle': '플래너 관리'
                                          ,'alertContent': `숫자만 입력하세요`
                                      });
        this.plannerPhone = a.substring(0, a.length - 1);
      }
    },
  },
  computed: {
      plannerInfo(){
        return this.$store.state.planner.plannerInfo;
      },
  },

  methods: {
    //우편번호, 주소 검색
    execDaumPostcode() {
        new window.daum.Postcode({
            oncomplete: (data) => {
              if (this.extraAddress !== "") {
                  this.extraAddress = "";
              }
              if (data.userSelectedType === "R") {
                  // 사용자가 도로명 주소를 선택했을 경우
                  this.address = data.roadAddress;
              } else {
                  // 사용자가 지번 주소를 선택했을 경우(J)
                  this.address = data.jibunAddress;
              }
      
              // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
              if (data.userSelectedType === "R") {
                  // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                  // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                  if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
                  this.extraAddress += data.bname;
                  }
                  // 건물명이 있고, 공동주택일 경우 추가한다.
                  if (data.buildingName !== "" && data.apartment === "Y") {
                  this.extraAddress +=
                      this.extraAddress !== ""
                      ? `, ${data.buildingName}`
                      : data.buildingName;
                  }
                  // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                  if (this.extraAddress !== "") {
                  this.extraAddress = `(${this.extraAddress})`;
                  }
              } else {
                  this.extraAddress = "";
              }
              // 우편번호를 입력한다.
              this.postalCode = data.zonecode;
            },
        }).open();
    },

    //편집 모드
    modifyMode(id){
      $('.class-' + this.modifyID).attr('class', 'list-group-item border-0 p-4 mb-2 mb-3 bg-gray-100 border-radius-lg class-' + this.modifyID);
      $('.editArea').attr('class', 'card editArea');

      this.modifyID = id;
      let tempInfo = this.$store.state.planner.plannerInfo.find(a => a._id == id);

      //왼쪽 정보 편집 창 데이터 바인딩
      this.plannerName = tempInfo.name;
      this.plannerTelecom = tempInfo.phone.telecom;
      this.plannerPhone = tempInfo.phone.phone;
      
      this.postalCode = tempInfo.address.postal_code;
      this.address = tempInfo.address.address;
      this.detailAddress = tempInfo.address.detail_address;
      this.extraAddress = tempInfo.address.extra_address;

      //왼쪽 정보 편집 창 상태 변경(버튼, border color 등 편집 상태임을 확인할 수 있도록)
      this.isModify = true;
      tempInfo = '';
      $('.class-' + this.modifyID).attr('class', 'list-group-item border-danger border-top p-4 mb-2 mb-3 bg-gray-100 border-radius-lg class-' + this.modifyID);
      $('.editArea').attr('class', 'card editArea border border-danger');
    },

    //입력 모드
    insertMode(){
      this.isModify = false;

      this.plannerName = '';
      this.plannerTelecom = '0';
      this.plannerPhone = '';
      
      this.postalCode = '';
      this.address = '';
      this.detailAddress = '';
      this.extraAddress = '';

      $('.class-' + this.modifyID).attr('class', 'list-group-item border-0 p-4 mb-2 mb-3 bg-gray-100 border-radius-lg class-' + this.modifyID);
      $('.editArea').attr('class', 'card editArea');
      this.modifyID = 0;
    },

    //편집 저장
    modifyPlannerInfo(){
      this.$store.dispatch('modifyPlannerInfo', { _id: this.modifyID
                                                  ,name: this.plannerName
                                                  ,phone: {
                                                            telecom: this.plannerTelecom
                                                            ,phone: this.plannerPhone
                                                          }
                                                  ,address: {
                                                            postal_code: this.postalCode
                                                            ,address: this.address
                                                            ,extra_address: this.extraAddress
                                                            ,detail_address: this.detailAddress
                                                          }
                                                  ,update_date: new Date().toLocaleString()
                                                  ,update_id: this.$store.state.login.loginID
                                                });
      this.insertMode();
    },

    //입력 저장
    insertPlannerInfo(){
      this.$store.dispatch('insertPlannerInfo', { name: this.plannerName
                                                  ,phone: {
                                                            telecom: this.plannerTelecom
                                                            ,phone: this.plannerPhone
                                                          }
                                                  ,address: {
                                                            postal_code: this.postalCode
                                                            ,address: this.address
                                                            ,extra_address: this.extraAddress
                                                            ,detail_address: this.detailAddress
                                                          }
                                                  ,insert_date: new Date().toLocaleString()
                                                  ,insert_id: this.$store.state.login.loginID
                                                });
      this.insertMode();
    },

    //삭제
    deletePlannerInfo(info){
      // if(confirm(`선택한 플래너 정보를 삭제하시겠습니까? \n\n>>이름: ${info.name} \n\n**삭제한 정보는 복구할 수 없으므로 신중히 삭제하시기 바랍니다.`)){
      //   this.$store.dispatch('deletePlannerInfo', info._id);
      // }
      this.$store.commit('setAlert', {
                                          'alertStatus': 'confirm'
                                          ,'alertTitle': '플래너 관리'
                                          ,'alertContent': `선택한 플래너 정보를 삭제하시겠습니까?|>>이름: ${info.name}| |**삭제한 정보는 복구할 수 없으므로 신중히 삭제하시기 바랍니다.`
                                          ,'callback': 'deletePlannerInfo'
                                          ,'parameter': {id: info._id}
                                      }
                          );
      this.insertMode();
    },

    //검색
    search(text){
      //console.log(this.$store.state.planner.plannerInfo);
      let temp = [];

      this.$store.state.planner.plannerInfoOrigin.forEach(a => {
        if(a.name.indexOf(text) > -1 || a.phone.phone.indexOf(text) > -1 || a.phone.telecom.indexOf(text) > -1
            || a.address.address.indexOf(text) > -1 || a.address.detail_address.indexOf(text) > -1 || a.address.extra_address.indexOf(text) > -1){
          temp.push(a);
        }
      })

      this.$store.state.planner.plannerInfo = temp;

      //console.log(this.$store.state.planner.plannerInfo);
    },
  },

  mounted() {
    //관리자만 이 페이지에 접근 가능
    if(!this.$store.state.login.userType == '관리자'){
      this.$router.push('/');
    }

    this.$store.state.isAbsolute = true;

    setNavPills();
    setTooltip();

    //플래너 정보 가져오기
    this.$store.dispatch('getPlannerInfo');

    //고객 정보 가져오기
    this.$store.dispatch('getPlannerInfo');

    let temp = $('.editArea > .card-body');
    let h = (temp.innerHeight() - temp.height()) / 2 + temp.height();
    $('.ulPlannerList').css('height', h);
  },

  beforeMount() {
      this.$store.state.imageLayout = "profile-overview";
      this.$store.state.showNavbar = true;
      this.$store.state.showFooter = true;
      this.$store.state.hideConfigButton = true;
      body.classList.add("profile-overview");
  },

  beforeUnmount() {
      this.$store.state.isAbsolute = false;
      this.$store.state.imageLayout = "default";
      this.$store.state.showNavbar = true;
      this.$store.state.showFooter = true;
      this.$store.state.hideConfigButton = false;
      body.classList.remove("profile-overview");
  },
};
</script>

<style>
</style>